import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from 'contents_modal';

import S3Upload      from 's3_upload';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class DraftAddMedia extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal: false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * データ編集
   */
  toggleEditMode(flg) {
    this.setState({ modal: flg });
  }
  // -------------------------------------------------------
  
  /*
   * データ編集
   */
  seMedia(url) {
    let data = this.props.data;
    let edit = this.props.edit;
    
    if( edit.media == undefined ) edit.media = {};
    if( edit.media[data.id] == undefined ) edit.media[data.id] = [];
    edit.media[data.id].push({ item_no: (this.props.no + 0.1), media_url: url, is_approval: 1 });
    
    this.props.update_ev.bind(this)(edit);
    this.setState({ modal: false })
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let edit_mode = this.props.edit_mode;
    if( edit_mode == false ) return null;
    
    return (
      <div className="add-draft-media">
        <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>画像・動画を追加する</Tooltip>}>
          <p className="add-button" onClick={this.toggleEditMode.bind(this)}>＋</p>
        </OverlayTrigger>
        
        <DraftAddMediaModal view={this.state.modal} set_ev={this.seMedia.bind(this)} close_ev={this.toggleEditMode.bind(this)} />
      </div>
    );
  }
}
// -------------------------------------------------------

class DraftAddMediaModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      event : {},
      upload_url : '',
    }
  }
  // -------------------------------------------------------
  
  /*
   * イベント設定
   */
  setEvent(column, ev) {
    let event = this.state.event;
    event[column] = ev;
    this.setState({ event: event });
  }
  // -------------------------------------------------------
  
  /*
   * データ更新時反映
   */
  actionProgress() {
    let media = this.state.event.get_media.bind(this)();
    this.setState({ upload_url: media[0].url });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let event = this.state.event;
    
    return (
      <ContentsModal
        view      = {this.props.view}
        width     = {350}
        height    = {250}
        close_ev  = {this.props.close_ev.bind(this, false)}
        html      = {
          <div className="modal-item add-draft-media-modal">
            
            <div className="upload-form">
              <S3Upload setEvent={this.setEvent.bind(this)} actionProgress={this.actionProgress.bind(this)} />
              
              <label>
                <input type="file" name="example" size="30" onChange={(e) => { event.file_upload.bind(this)(e, 'draft/') }} />
                <span>ファイルを選択</span>
              </label>
            </div>
            
            { (this.state.upload_url != '') &&
              <div className="sample-media">
                { (!Utils.isVideo(this.state.upload_url))
                  ? <div className="thumbnail"><img src={this.state.upload_url} onError={(e)=>{e.target.src=this.state.upload_url}} /></div>
                  : <div className="thumbnail"><video src={this.state.upload_url} onError={(e)=>{e.target.src=this.state.upload_url}} /></div>
                }
              </div>
            }
            
            { (this.state.upload_url != '') &&
              <div className="button" onClick={this.props.set_ev.bind(this, this.state.upload_url)}>メディアを適用する</div>
            }
          </div>
        }
      />
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftAddMedia;